"use client";

import { createContext } from "react";
import { DEFAULT_LOCALE, type Locale } from "./i18n-locale";

/**
 * Per-request locale, published by `LocaleProvider` from the `ui-locale` cookie.
 *
 * It exists in its own module purely to break a cycle: `lib/i18n.ts` reads it
 * (it is the server snapshot for `useTranslation`) and `lib/i18n-provider.tsx`
 * writes it while importing the store from `lib/i18n.ts`.
 *
 * Why a context and not the module-level store: on the server the store is
 * process-global and shared by every concurrent render, so seeding it per
 * request would let one user's locale leak into another's HTML. Context is
 * render-scoped and therefore the only request-safe carrier.
 */
export const LocaleContext = createContext<Locale>(DEFAULT_LOCALE);
